import styled from "styled-components";

export const custom_font_family = "HelveticaNeue, Helvetica, Aria";

export const Container = styled.div`
  font-family: ${custom_font_family};
  /* color: white; */
  text-align: ${props => (props.center ? "center" : "left")};
`;

export const CenteredContent = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${props => props.maxWidth || ""};
`;

export const Title = styled.div`
  font-family: ${custom_font_family};
  font-weight: bold;
  text-align: ${props => (props.center ? "center" : "")};
  display: ${props => (props.inline ? "inline" : "")};
  letter-spacing: -0.02em;
`;
export const Text = styled.div`
  display: ${props => (props.block ? "block" : "inline")};
  margin-bottom: ${props => (props.block ? "10px" : "auto")};
  text-align: ${props => (props.center ? "center" : "")};
  line-height: 1.6em;
  @media only screen and (min-width: 768px) {
    line-height: 1.2em;
  }
`;

export const Link = styled.a`
  font-size: 12px;
  opacity: ${props => (props.disabled ? 0.3 : 1)};
  cursor: ${props => (props.disabled ? "not-allowed" : "default")};
  text-decoration: none;

  &,
  &:focus,
  &:active,
  &:hover {
    color: currentColor;
  }
`;

export const Header = styled.header.attrs({
  className: "header"
})`
  position: relative;
  // margin: 0 0 60px;
  padding: unset;
  height: 60px;
  display: flex;
  align-items: center;

  .header {
    &__locale-menu {
      margin: 0 10px;
      position: absolute;
      right: 3%;
      top: 50%;
      transform: translateY(-50%);
      font-family: ${custom_font_family};
    }
  }
`;

export const HeaderLogo = styled.div.attrs({
  className: "header__logo"
})`
  width: 40%;
  max-width: 309px;
  margin: 0 auto;

  img {
    display: block;
    height: 24px;
    width: 24px;
    margin: 0 auto;
  }
`;

export const HeaderTitle = styled.div.attrs({
  className: "header__title"
})`
  max-width: 309px;
  margin: auto;
  margin-top: 22px;
`;

export const Dropdown = styled.div.attrs({
  className: "dropdown"
})`
  position: relative;
  text-transform: uppercase;

  .dropdown {
    &__label {
      position: relative;

      padding-top: 5px;
      padding-bottom: 5px;
      padding-right: 13px;
      margin-top: 5px;
      cursor: pointer;

      &:before {
        content: "▾";
        /* Hide Text */
        text-indent: 20000%;
        overflow: hidden;
        white-space: nowrap;
        /* draw triangle */
        border-style: inset;
        /* transform: rotate(-90deg); */
        width: 0;
        height: 0;
        border: transparent solid 0;
        border-top-width: 4px;
        border-right-width: 4px;
        border-left-width: 4px;
        border-top-color: currentColor;
        /* position */
        position: absolute;
        top: calc(50% - 2px);
        right: 0;
        /* transition */
        transition: transform 0.2s;
      }
    }

    &__list {
      display: none;
      list-style: none;
      padding-left: 13px;
      min-width: 180px;
      position: absolute;

      li {
        a,
        span {
          display: block;
          padding: 5px 0 5px 13px;
          margin-left: -13px;
        }
      }
    }

    &__toggle {
      &:checked {
        ~ .dropdown__list {
          display: block;
        }
        ~ .dropdown__label:before {
          transform: rotate(0deg);
        }
      }
    }
  }
`;

export const HeroBanner = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 125.625%;

  background-color: transparent;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  background-image: url('${props => props.src || ""}');
  @media only screen and (min-width: 768px) {
    background-image: url('${props => props.srcMd || ""}');

    padding-bottom: 46.39%;
  }

  @media only screen and ( min-device-pixel-ratio: 2), only screen and ( min-resolution: 192dpi), only screen and ( min-resolution: 2dppx) {
    background-image: url('${props => props.src2x || ""}');
    @media only screen and (min-width: 768px) {
      background-image: url('${props => props.srcMd2x || ""}');
    }
  }
`;



// WEBPACK FOOTER //
// ./src/styles/base.js